export interface ServiceOption {
  ServiceOptionID: string;
  ServiceOptionLabel: string;
  ServiceOptionMessage: string;
  ServiceOptionType: string;
  ServiceOptionCost: string;
  ServiceOptionRequiredFields: string[];
  CurrentlySelected?: boolean;
}
